export type SortByFunc<T> = (a: T, b: T) => number;

export function sortByFuncBuilder<T>(key: (a: T) => string): SortByFunc<T> {
  return (a: T, b: T) => {
    const ka = key(a);
    const kb = key(b);
    return ka < kb ? -1 : ka > kb ? 1 : 0;
  };
}
